<template>
  <v-app-bar
    class="bcl-app-header px-2 px-sm-3 px-md-4"
    location="top"
    app
    fixed
  >
    <TopBarSkeleton v-if="!isSdkInitialized" />
    <div v-else class="container d-flex align-center ga-1 ga-lg-2">
      <div class="d-flex align-center">
        <AppLogo class="logo-btn mr-md-3 mr-lg-6" linked />

        <template v-if="!smAndDown">
          <v-btn
            v-for="({ routeName, text }, index) in menuItems"
            :key="index"
            class="menu-link"
            :color="route.name === routeName ? 'secondary' : 'primary'"
            :to="{ name: routeName }"
            exact
          >
            {{ text }}
          </v-btn>
        </template>
      </div>

      <v-spacer />

      <div class="d-flex align-center ga-0 ga-md-1 ga-lg-2">
        <NetworkSelector v-if="!smAndDown" />
        <ToggleDarkMode />
        <CurrencySelector v-if="!smAndDown" />
        <LanguageSelector />
        <WalletConnectBtn size="large" outlined />
        <ActiveAccountBtn v-if="isSdkInitialized" />
      </div>
    </div>
  </v-app-bar>
</template>

<script lang="ts" setup>
import { useDisplay } from "vuetify";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { storeToRefs } from "pinia";

import { useAppStore } from "@/stores";

import {
  ROUTE_ABOUT,
  ROUTE_CREATE_TOKEN,
  ROUTE_HOME,
  ROUTE_INVITE,
} from "@/utils/constants";

import ActiveAccountBtn from "@/components/Account/ActiveAccountBtn.vue";
import WalletConnectBtn from "@/components/WalletConnect/WalletConnectBtn.vue";
import ToggleDarkMode from "@/components/Header/ToggleDarkMode.vue";
import NetworkSelector from "@/components/Header/NetworkSelector.vue";
import CurrencySelector from "@/components/Header/CurrencySelector.vue";
import LanguageSelector from "@/components/Header/LanguageSelector.vue";
import AppLogo from "@/components/Common/AppLogo.vue";
import TopBarSkeleton from "@/components/Skeletons/TopBarSkeleton.vue";

const route = useRoute();
const { smAndDown } = useDisplay();
const { t } = useI18n();
const { isSdkInitialized } = storeToRefs(useAppStore());

const menuItems = [
  {
    routeName: ROUTE_HOME,
    text: t("common.tokenList"),
  },
  {
    routeName: ROUTE_CREATE_TOKEN,
    text: t("blocks.appHeader.createToken"),
  },
  {
    routeName: ROUTE_INVITE,
    text: t("blocks.appHeader.invite"),
  },
  {
    routeName: ROUTE_ABOUT,
    text: t("blocks.appHeader.about"),
  },
];
</script>

<style scoped lang="scss">
@use "@/styles/variables" as *;

.bcl-app-header {
  background-color: $color-card-bg-transparent;
  backdrop-filter: blur(8px);
  box-shadow: 2px 0 20px rgba(var(--v-theme-background), 0.9) !important;

  .menu-link {
    font-family: $body-font-family;
    font-size: 17px;
    font-weight: 600 !important;
    letter-spacing: 1px;
  }
}
</style>
